import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

const DepartmentDetailsModal = props => {
  const { isOpen, toggle, department } = props
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Department Details</ModalHeader>
        <ModalBody>
          <h6 className="mb-2">
            Department id:{" "}
            <span className="text-primary">#{department?._id}</span>
          </h6>
          <h6 className="mb-4">
            Name: <span className="text-primary">{department?.name}</span>
          </h6>
          <p className="mb-2">
            Description:{" "}
            <span className="text-primary">{department?.description}</span>
          </p>
          <p className="mb-2">
            Company:{" "}
            <span className="text-primary">{department?.companyName}</span>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DepartmentDetailsModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  department: PropTypes.object,
}

export default DepartmentDetailsModal
